export const toLocalISOString = (input) => {
    if (!input) return '';
    const date = new Date(input);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date.toISOString().slice(0, 16); 
};

export const fromLocalInputToUTCISOString = (input) => {
    if (!input) return '';
    const date = new Date(input);
    return date.toISOString(); 
};
